export const FEATURE_NAME = '@zerops/zui/user-info-fields';
